import React, { createContext, useContext, useEffect, useState } from "react";
import api, { LOGO_URL } from "@/lib/api";

const SettingsContext = createContext({});
export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  const refresh = () =>
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});

  useEffect(() => {
    refresh();
  }, []);

  const logo = (settings && settings.logo) || LOGO_URL;

  return (
    <SettingsContext.Provider value={{ settings, logo, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};
